<p class="title">
    <!--  <img class="icon-title" src="assets/images/add_circle_outline.svg" alt="Image" />
    Adicionar Nova Cidade-->
</p>
<div class="container">
    <p-tabView>
        <p-tabPanel [header]="tabs.lista_de_notas">
            <div class="tabPanel-container">
                <div class="item item1">
                    <app-pessoas-table [pessoaId]="pessoaId"></app-pessoas-table>
                </div>
                <div class="item item2">
                    <app-pessoas-card [pessoaId]="pessoaId" [IsFornecedor]="IsFornecedor"></app-pessoas-card>
                </div>
            </div>
        </p-tabPanel>
        <p-tabPanel [header]="tabs.lista_de_produtos" *ngIf="IsFornecedor">
            <div class="tabPanel-container">
                <div class="item item1">
                    <app-pessoa-items-table [pessoaId]="pessoaId"></app-pessoa-items-table>
                </div>
                <div class="item item2">
                    <app-pessoas-card [pessoaId]="pessoaId" [IsFornecedor]="IsFornecedor"></app-pessoas-card>
                </div>
            </div>
        </p-tabPanel>
        <p-tabPanel [header]="tabs.movimentacoes">
            <div class="tabPanel-container">
                <div class="item item1">
                    <app-pessoa-movimentacao-table [pessoaId]="pessoaId"></app-pessoa-movimentacao-table>
                </div>
                <div class="item item2">
                    <app-pessoas-card [pessoaId]="pessoaId" [IsFornecedor]="IsFornecedor"></app-pessoas-card>
                </div>
            </div>
        </p-tabPanel>
    </p-tabView>
</div>
